import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  transcribeAudioApiService,
  type SourcedWhere,
  type TranscribeAudioResponse,
} from "@/generated/fastapi";

export async function transcribeAudio(
  accessToken: string | null | undefined,
  sourcedWhere: SourcedWhere,
  file: File,
): Promise<TranscribeAudioResponse> {
  const response = await transcribeAudioApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: { file: file as unknown as string },
    query: {
      sourced_where: sourcedWhere,
    },
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to transcribe audio (${response.status})`);
  }

  if (response.data.status !== "success") {
    throw new Error(response.data.message || "Failed to transcribe audio");
  }

  return response.data;
}
